import { fg } from '@atlassian/jira-feature-gating';

const isIssueSearchWarningsEnabled = {
	get(): boolean {
		return fg('jira_issue_search_warnings_banner');
	},
};

export default isIssueSearchWarningsEnabled;
